import styled from "@emotion/styled";
import { Divider, Link, Typography } from "@mui/material";
import React from "react";
import themes from "../../../themes";

interface FooterProps {}

export const Footer = ({ ...props }: FooterProps) => {
  return (
    <StyledFooter>
      <Copyright align="center">
        Copyright © CHIMNEY TOWN {new Date().getFullYear()}.
      </Copyright>
    </StyledFooter>
  );
};

const StyledLink = styled(Link)`
  font-size: 14px;
`;

const LinkWrapper = styled.div`
  & > span {
    padding: 0 8px;
  }
  @media screen and (max-width: 420px) {
    display: block;
    & > span {
      display: none;
    }
    & > a {
      display: block;
      padding: 16px 24px;
      border-bottom: 1px solid #fff;
    }
  }
`;

export const StyledDivider = styled(Divider)`
  border-color: #fff;
`;

const StackWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${themes.spacing(1)};
  margin-bottom: ${themes.spacing(2)};
  background-color: #ffffff5c;
  @media screen and (max-width: 420px) {
    display: block;
    padding: 0;
  }
`;

const StyledFooter = styled.div`
  background-color: ${themes.palette.primary.main};
  color: #fff;
`;

const Copyright = styled(Typography)`
  font-size: 10px;
  font-weight: bold;
  padding-top: ${themes.spacing(2)};
  padding-bottom: ${themes.spacing(2)};
`;
